module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-section"
  }, [_vm._m(0), _c('div', {
    staticClass: "cards-grid"
  }, _vm._l((_vm.lista), function(item) {
    return _c('StatCard', {
      key: item.id,
      attrs: {
        "titulo": item.titulo,
        "descripcion": item.descripcion,
        "cantidad": item.cantidad,
        "tipo": item.tipo,
        "centrado": true
      },
      on: {
        "click": function($event) {
          return _vm.redirigir(item.ruta)
        }
      }
    })
  }), 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("Pendientes como jefe")]), _c('p', [_vm._v("Solicitudes que necesitan revisión o aprobación.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04b8f6ba","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/dashboard/c_pendiente_jefe.vue
// module id = 809
// module chunks = 0